import {
  FETCH_ORDER_HISTORY_FAILURE,
  FETCH_ORDER_HISTORY_REQUEST,
  FETCH_ORDER_HISTORY_SUCCESS,
  FETCH_TOTAL_ORDER_HISTORY_FAILURE,
  FETCH_TOTAL_ORDER_HISTORY_SUCCESS,
} from "./type.js";

const initialState = {
  isLoading: false,
  error: "",
  ordersData: [],
  totalPages: 0,
  totalOrdersData: [],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ORDER_HISTORY_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case FETCH_ORDER_HISTORY_SUCCESS:
      return {
        ...state,
        isLoading: false,
        ordersData: action.payload.data,
        totalPages: action.payload.totalPages,
        error: "",
      };
    case FETCH_ORDER_HISTORY_FAILURE:
      return {
        ...state,
        isLoading: false,
        ordersData: [],
        totalPages: 0,
        error: action.payload,
      };
    case FETCH_TOTAL_ORDER_HISTORY_SUCCESS:
      return {
        ...state,
        totalOrdersData: action.payload.data,
        error: "",
      };
    case FETCH_TOTAL_ORDER_HISTORY_FAILURE:
      return {
        ...state,
        totalOrdersData: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
